import React, { useMemo, useEffect } from "react";
import { useDispatch } from "react-redux";

import { getCapacityAssessmentTypes } from "common/services/capacity-assessments.service";
import { normalize } from "common/lib/normalize";
import { FilterSelect } from "Components/Common/TableFilters";

const SelectTypeFilter = ({
  filterValue,
  setFilterValue,
}: {
  filterValue: any;
  setFilterValue: (value: any) => void;
}) => {
  const dispatch: any = useDispatch();

  const [loading, setLoading] = React.useState<boolean>(false);
  const [data, setData] = React.useState<any>([]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await getCapacityAssessmentTypes({});
        setData(normalize(response.data));
      } catch (err: any) {
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name}`,
      };
    });
  }, [data]);

  return (
    <FilterSelect
      id="capacityAssessmentType"
      placeholder="Select type"
      value={filterValue?.capacityAssessmentType}
      onChange={setFilterValue}
      options={options}
      isLoading={loading}
    />
  );
};

export default SelectTypeFilter;
